import { render, staticRenderFns } from "./CatalogSongDetail.vue?vue&type=template&id=0b6754c4"
import script from "./CatalogSongDetail.vue?vue&type=script&lang=ts"
export * from "./CatalogSongDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports